import React, { useState, useEffect } from 'react'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../message/errorMessage/ErrorMessage'
import { DOMHelper } from 'rsuite'

import {
  Form,
  Input,
  Checkbox,
  Message,
  Row,
  Col,
  Panel,
  CheckboxGroup,
  List,
  ButtonGroup,
  Button,
  Icon,
  InputGroup,
} from 'rsuite'

export default function TransferList({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  formKey,
  getValues,
  ...props
}) {
  const { addStyle } = DOMHelper
  const [schema, setSchema] = useState(_schema)
  const [defaultValue, setDefaultValue] = useState([])
  const [selectedValue, setSelectedValue] = useState([])
  const [selectedId, setSelectedId] = useState([])

  const _style = {
    panelHeader: { textAlign: 'center', color: '#ffffff', fontWeight: 'bold' },
    panelBody: {
      marginLeft: '-18px',
      marginRight: '-18px',
      marginBottom: '-18px',
      borderRadius: '0px',
      minHeight: '300px',
    },
  }

  useEffect(() => {
    console.log('852')
  }, [])

  const handleChange = (value) => {
    console.log('value => ', value)

    setSelectedId(value)
  }

  const onAdd = () => {
    // console.log('data onAdd => ', selectedId)

    selectedId.map((id) => {
      addArray(id)
      removeArray(id)
    })
  }

  const addArray = (id) => {
    let arr = schema.list.selectedValue.itemList
    schema.list.defaultValue.itemList.map((item) => {
      if (item.value == id) {
        arr.push(item)
      }
    })

    setSelectedValue(arr)
  }

  const removeArray = (id) => {
    console.log('removeArray id => ', id)
    delete schema.list.defaultValue.itemList[id - 1]
    setSelectedId([])
  }

  const generateCheckbox = (itemList) => {
    // console.log('itemList ', itemList)
    return itemList.map((item, index) => {
      return (
        <>
          <Checkbox value={item.value} disabled={item.disabled} key={index}>
            {item.value + ' ' + item.label}
          </Checkbox>
        </>
      )
    })
  }

  return (
    <>
      <Form>
        <Row>
          <Col lg={10} md={10} sm={10} xs={10} style={{ marginTop: '5px', padding: '8px' }}>
            {schema?.list.defaultValue && (
              <Panel
                bordered
                header={<div style={_style.panelHeader}>{schema.list.defaultValue.title}</div>}
                style={{
                  backgroundColor: '#80808085',
                }}
              >
                <Panel bordered style={_style.panelBody}>
                  <InputGroup>
                    <Input placeholder={'ค้นหา'} />
                    <InputGroup.Button>
                      <Icon icon="search" />
                    </InputGroup.Button>
                  </InputGroup>
                  <Controller
                    key={schema.list.defaultValue.name}
                    name={schema.list.defaultValue.name}
                    control={control}
                    rules={isValidators(schema.list.defaultValue.validators)}
                    defaultValue={selectedId}
                    render={(props) => {
                      return (
                        <CheckboxGroup
                          name={schema.list.defaultValue.name}
                          // value={selectedId}
                          onChange={handleChange}
                        >
                          {schema.list.defaultValue.itemList.map((item, index) => {
                            return (
                              <Checkbox value={item.value} disabled={item.disabled} key={index}>
                                {item.label}
                              </Checkbox>
                            )
                          })}
                        </CheckboxGroup>
                      )
                    }}
                  />
                </Panel>
              </Panel>
            )}
          </Col>
          <Col lg={4} md={4} sm={4} xs={4} style={{ marginTop: '5px', padding: '8px' }}>
            <ButtonGroup vertical style={{ width: '100%', marginTop: '50%' }}>
              <Button appearance="primary" style={{ height: '45px' }} onClick={onAdd}>
                <Icon icon="angle-right" size="2x" />
              </Button>
              <Button appearance="primary" style={{ height: '45px' }}>
                <Icon icon="angle-double-right" size="2x" />
              </Button>
              <Button appearance="primary" style={{ height: '45px' }}>
                <Icon icon="angle-left" size="2x" />
              </Button>
              <Button appearance="primary" style={{ height: '45px' }}>
                <Icon icon="angle-double-left" size="2x" />
              </Button>
            </ButtonGroup>
          </Col>
          <Col lg={10} md={10} sm={10} xs={10} style={{ marginTop: '5px', padding: '8px' }}>
            {schema?.list.selectedValue && (
              <Panel
                bordered
                header={<div style={_style.panelHeader}>{schema.list.selectedValue.title}</div>}
                style={{
                  backgroundColor: '#80808085',
                }}
              >
                <Panel bordered style={_style.panelBody}>
                  <InputGroup>
                    <Input placeholder={'ค้นหา'} />
                    <InputGroup.Button>
                      <Icon icon="search" />
                    </InputGroup.Button>
                  </InputGroup>
                  <Controller
                    key={schema.list.selectedValue.name}
                    name={schema.list.selectedValue.name}
                    control={control}
                    rules={isValidators(schema.list.selectedValue.validators)}
                    defaultValue={selectedId}
                    render={(props) => {
                      return (
                        <CheckboxGroup
                          name={schema.list.selectedValue.name}
                          // value={selectedId}
                          onChange={handleChange}
                        >
                          {selectedValue.map((item, index) => {
                            return (
                              <Checkbox value={item.value} disabled={item.disabled} key={index}>
                                {item.label}
                              </Checkbox>
                            )
                          })}
                        </CheckboxGroup>
                      )
                    }}
                  />
                </Panel>
              </Panel>
            )}
          </Col>
        </Row>
      </Form>
    </>
  )
}
